<ul
  nz-menu
  nzInlineCollapsed="false"
  nzMode="inline">
  @for (item of navigationItems; track item.label) {
    <li
      nz-submenu
      [nzOpen]="true"
      [nzPaddingLeft]="0"
      [nzTitle]="item.label | transloco">
      <ul>
        @for (child of item.children; track child.label; let index = $index) {
          @if (child.page && !child.children) {
            <li
              nz-menu-item
              [nzPaddingLeft]="0"
              [nzSelected]="child.page === currentPage">
              <a
                [queryParams]="{ page: child.page }"
                [routerLink]="['./']"
                >{{ child.label | transloco }}</a
              >
            </li>
          }
          @if (child.children) {
            <!-- if we want to have section clickable, need to by styled as nz-menu-group -->
            @if (child.page) {
              <li
                class="as-group"
                nz-menu-item
                [nzPaddingLeft]="1"
                [nzSelected]="child.page === currentPage">
                <a
                  [queryParams]="{ page: child.page }"
                  [routerLink]="['./']"
                  >{{ child.label | transloco }}</a
                >
              </li>
            } @else {
              <li
                nz-menu-group
                [nzTitle]="child.label | transloco"></li>
            }
            @for (child of child.children; track child.label) {
              <li
                nz-menu-item
                [nzPaddingLeft]="16"
                [nzSelected]="child.page === currentPage">
                <a
                  [queryParams]="{ page: child.page }"
                  [routerLink]="['./']"
                  >{{ child.label | transloco }}</a
                >
              </li>
            }
          }
        }
      </ul>
    </li>
  }
</ul>
